<template>
    <grid-loader :loading="isLoading" :color="spinnerColor" class="middle_abs"></grid-loader>
  
      <div style="padding:30px" v-if="!isLoading&&saidaos!=undefined">
        <div class="d-flex justify-content mt-2">
          <template v-for="(saidao,g_index) in saidaos" :key="g_index">
                <div :class="selected_saidao!=undefined&&selected_saidao==saidao.objectId?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="choose_saidao(saidao)">{{saidao.name }}</div>
          </template>
         
        </div>
        
        <div v-if="selected_saidao!=undefined&&ups!=undefined">
        <div v-if=" ups.length==0" class="title mt-2">暂无账号</div>
        <div  v-else class="mt-2">
          显示最热20条笔记
          <div class="d-flex justify-content">
               <div :class="sort=='likes'?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="get_hot('likes')">点赞</div>

                <div :class="sort=='collects'?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="get_hot('collects')">收藏</div>

                <div :class="sort=='comments'?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="get_hot('comments')">评论</div>

                <div :class="sort=='shares'?'normalNav mr-1 selectedNav':'normalNav mr-1 unselectedNav'" 
                @click="get_hot('shares')">评论</div>
          </div>
           

          <div v-for="(up,index) in ups" :key="index">
            <div class="mt-2 d-flex justify-content-between secondColor">
                <div><a :href="`https://www.xiaohongshu.com/user/profile/${up.user_id}?xsec_token=${up.xsec_token}&xsec_source=pc_feed`" target="blank" v-if="up.xsec_token!=undefined ">{{up.user_id}}查看博主</a></div>
                
                <div>添加日期：{{ formatStamp(up.createdDate) }}</div>
                <div class="backBtn" @click="deleteUp(up.objectId,index)">删除</div>
            </div>
            <div v-if="(up.notes!=undefined&& up.notes.length>0)" class="d-flex justify-content">
              <template v-for="(note,index) in up.notes" :key="index">

                <div  class="mt-1 card col-auto m-1">
              <div>
                     
                <img :src="note.imgs[0]" class="img" v-if="note.imgs!=undefined && note.imgs.length>0">
                       
               </div>
              
               <div class="cardText p-1 d-flex flex-column justify-content-evenly">
                <div>{{ note.title}}
                 
                <div>日期：{{ formatStamp(note.publish_time) }}</div>
                <div class="d-flex justify-content-between mt-1">
      
                  <a :href="`https://www.xiaohongshu.com/explore/${note.note_id}?xsec_token=${note.xsec_token}&xsec_source=pc_creatormng&source=web_explore_feed`" target="blank" v-if="note.note_id !== undefined &&note.xsec_token!=undefined ">查看小红书</a>
                </div>               
                <div class="d-flex justify-content-between mt-1">
                 
                  <div v-if="note.likes!=undefined" class="d-flex align-items-center">
                    <img src="../assets/like_icon.png" class="icon"><span>{{ note.likes }}</span>
                    <img src="../assets/fire.png" v-if="note.likes>100" class="icon">
                  </div>

                  <div v-if="note.collects!=undefined" class="d-flex align-items-center">
                    <img src="../assets/collect_icon.png" class="icon"><span>{{ note.collects }}</span>
                    <img src="../assets/fire.png" v-if="note.collects>100" class="icon">
                  </div>

                  <div v-if="note.shares!=undefined" class="d-flex align-items-center">
                    <img src="../assets/resend_icon.png" class="icon"><span>{{note.shares }}</span>
                    <img src="../assets/fire.png" v-if="note.shares>100" class="icon">
                  </div>

                  <div v-if="note.comments!=undefined" class="d-flex align-items-center">
                    <img src="../assets/comment_icon.png" class="icon"><span>{{note.comments}}</span>
                    <img src="../assets/fire.png" v-if="note.comments>50" class="icon">
                  </div>
                </div>
                <div class="mb-1 secondColor">数据: {{ formatDate(note.updatedDate) }}</div>

                <a :href="`https://www.xiaohongshu.com/user/profile/${note.up_id}?xsec_token=${note.user_xsec_token}&xsec_source=pc_feed`" target="blank" v-if="note.user_xsec_token!=undefined ">{{note.up_id}}查看博主</a>
               <div>
              </div>
               

             

             
               

               </div>
              
            </div>
       
              
              
               
               
            
              
              </div>
               
             
              </template>
            </div>
            <div v-else class="secondColor">暂无笔记</div>
        </div>

      </div>
        <div>
        </div>
      </div>

        <div class="mt-1 mb-1 d-flex justify-content" v-if="totalPage>1">

          <div v-for="(n,index) in totalPage" :key="index">
            <div :class="n==page+1?'pageBox mr-1 selectedPageBox':'pageBox mr-1 normalPage'" @click="changePage(n)">
              {{ n }}
            </div>
            
          </div>

        </div>
  </div>


  
      <div>



        
</div>
      
  </template>
  
  <script>
  
  import GridLoader from 'vue-spinner/src/GridLoader.vue'
  import axios from 'axios';
  
  import moment from 'moment';


  
  export default {
    data(){
      
      return {
        
        isLoading:false,
        saidaos:null,
        ups:null,
        spinnerColor:"#262626",
        errors:'',
        selected_saidao:null,
        sort:null,
        saved_ups:null,
        totalPage:0,
        perPage:10,
        page:0
        
      }
      
    },
   
    components: {
      GridLoader,


    },
    computed: {
    countDown() {
      return `${this.count}秒`
    },
    localDatetime() {
       return (datetimeString) => {
         let beijingTime = moment(datetimeString).utcOffset('+08:00').format('YYYY-MM-DD');
         return beijingTime
         
       }
     },
    formatDate(){
      return (datetimeString) => {
         let beijingTime = moment.utc(datetimeString).format('YYYY-MM-DD');
         return beijingTime
         
       }
     },

      formatStamp() {
        return(timestamp)=>{
            const date = new Date(timestamp); // 注意：JavaScript 使用毫秒，所以 ×1000
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从 0 开始
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;

        }
         
        }
  },
     setup(){
      
       var token=localStorage.getItem('sessionToken')
       axios.defaults.headers.common['X-Parse-Session-Token'] = token

       
  
    },
  
   
  
    mounted(){
      var token=localStorage.getItem('sessionToken');
       var role=localStorage.getItem('role');
  
       if(token==undefined || token==null ||token=='' || role==undefined||role!=1)
       {
          this.$router.push('index')
          return
       }
      

      // this.selected_saidao=localStorage.getItem('selected_saidao')
      console.log(this.selected_saidao)
      this.getSaidaos()
    
    
    },
    methods:{ 
      choose_saidao(saidao){
        this.selected_saidao=saidao.objectId
        localStorage.setItem('selected_saidao',saidao.objectId)
        this.getUpsCount()
      },
    changePage(n){
       this.page=n-1
      this.getUps()
    },
     async getUpsCount(){
        this.isLoading=true
        try{
          const response = await axios.get(this.domain+'xhs/get_ups_count?saidao_id='+this.selected_saidao);
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            var count=data.ups
            this.totalPage=Math.ceil(count/this.perPage)
            this.page=0
            this.isLoading=false
            this.getUps()
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error){
          this.isLoading=false
          this.errors=error
        }
      },

     async getSaidaos(){
        this.isLoading=true
        try{
          const response = await axios.get(this.domain+'xhs/saidaos');
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            this.saidaos=data.saidaos
              if(this.selected_saidao!=undefined)
              {
                this.getUpsCount()
              }
      
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
       
      },


      async getUps(){
        if(!this.isLoading)
      {
        this.isLoading=true
      }
        try{
          const response = await axios.get(this.domain+'xhs/get_ups?saidao_id='+this.selected_saidao+'&page='+this.page+'&count='+this.perPage);
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            this.ups=data.ups
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
       
      },

        get_hot(sort){
          if(this.sort==sort)
        {
          this.sort=null
          this.ups=this.saved_ups
        }
        else
        { 
          
            this.sort=sort
            this.saved_ups=this.ups
            this.getHots()

        }
           
          },
      
      async getHots(){
        if(!this.isLoading)
      {
        this.isLoading=true
      }
        try{
          const response = await axios.get(this.domain+'xhs/get_hot_up_nots?saidao_id='+this.selected_saidao+'&sort='+this.sort);
          var data=response.data
          console.log(data)
          if(data.status=='Suc')
          {
            var notes=data.notes
            var emptyup={'user_id':'','notes':notes}
            this.ups=[emptyup]
          
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
       
      },
   
     

    async deleteUp(up_id,index){
      if (window.confirm("确定要删除此用户吗?")) {

        this.isLoading=true
        try{
          
          const response = await axios.get(this.domain+'xhs/delete_up?up_id='+up_id);
          var data=response.data
          if(data.status=='Suc')
          {
            this.ups.splice(index,1)
            
          }
          else
          {
            this.errors=data['msg']
          }
        }
        catch(error)
        {
          this.errors=error
        }
        finally
        {
          this.isLoading=false
        }
      }

    }
      
  
   
      
    }
     
    
  };
  </script>
  <style scoped>
  
  .account_icon{
    width: 28px;
  height: 28px;
  border-radius: 28px;
  }
  
  .operationIcon{
    width:24px;
    height:24px;
    cursor:pointer
  }
  
  .textbox_label{
    align-self: stretch;
   color: #262626;
   font-family: "Alibaba PuHuiTi";
   font-size: 14px;
   font-style: normal;
   font-weight: 400;
   line-height: normal;
  }
  .textBox{
    width:300px;
  }
  
  .dropdown{
    width: 130px;
  }
  
  .submitBtn{
  
   width: 300px;
  }
  
  .error-message{
    color:red
  }

  .template{
    font-weight: bold;
    color:blue
  }

  .img{
    width:100%;
    border-radius: 0.125rem, 0.125rem,0 0;
}

.card{
  height:max-content;
  min-width: 2rem;
  max-width: 3rem;
}

.cardText{
  color: #262626;
 font-family: "Alibaba PuHuiTi";
 font-size: 0.175rem;
 font-style: normal;
 font-weight: 500;
 text-align: left;
}
.icon{
  width:0.175rem;
  height:0.175rem;
}

.account_icon{
  width:0.5rem;
  height:0.5rem;
  border-radius: 50%;
}
  </style>
  
  
  